/* =========================================================================
   SENİN KUTUM — Duyuru şeridi (Katman 1) carousel + countdown
   Vellum mimarisi uyarlandı; bağımsız custom element.
   ========================================================================= */
(function () {
  'use strict';

  if (customElements.get('sk-announcement')) return;

  class SkAnnouncement extends HTMLElement {
    constructor() {
      super();
      this.slides = [];
      this.index = 0;
      this.timer = null;
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-sk-slide]'));
      this.prevBtn = this.querySelector('[data-sk-prev]');
      this.nextBtn = this.querySelector('[data-sk-next]');

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.index - 1, true));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.index + 1, true));

      this.initDismiss();
      this.initCountdowns();

      if (this.hasAttribute('data-autoplay') && this.slides.length > 1) {
        this.startAutoplay();
        // Fare üstündeyken duraklat (premium detay)
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    go(next, userInitiated) {
      var total = this.slides.length;
      if (total === 0) return;
      this.index = ((next % total) + total) % total; // döngüsel
      this.slides.forEach(function (slide, i) {
        if (i === this.index) {
          slide.removeAttribute('hidden');
        } else {
          slide.setAttribute('hidden', '');
        }
      }, this);
      // Kullanıcı elle gezerse autoplay'i sıfırla
      if (userInitiated && this.hasAttribute('data-autoplay')) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    startAutoplay() {
      this.stopAutoplay();
      var speed = (parseFloat(this.getAttribute('data-speed')) || 5) * 1000;
      var self = this;
      this.timer = setInterval(function () {
        self.go(self.index + 1, false);
      }, speed);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    initDismiss() {
      if (!this.hasAttribute('data-dismissible')) return;
      var closeBtn = this.querySelector('[data-sk-close]');
      if (!closeBtn) return;

      var sectionId = this.getAttribute('data-section-id') || 'default';
      var storageKey = 'sk-topbar-dismissed-' + sectionId;
      var section = this.closest('.sk-topbar-section');

      // Daha önce kapatılmışsa gizli başlat
      try {
        if (localStorage.getItem(storageKey) === '1' && section) {
          section.classList.add('sk-dismissed');
        }
      } catch (e) {}

      var self = this;
      closeBtn.addEventListener('click', function () {
        if (section) section.classList.add('sk-dismissed');
        self.stopAutoplay();
        try { localStorage.setItem(storageKey, '1'); } catch (e) {}
      });
    }

    initCountdowns() {
      var countdowns = this.querySelectorAll('[data-sk-countdown]');
      countdowns.forEach(function (el) {
        var endStr = el.getAttribute('data-end');
        var end = new Date(endStr.replace(' ', 'T')).getTime();
        if (isNaN(end)) return;
        var timeEl = el.querySelector('[data-sk-countdown-time]');
        var expiredEl = el.querySelector('[data-sk-countdown-expired]');
        var behavior = el.getAttribute('data-expired');
        var slide = el.closest('[data-sk-slide]');

        function tick() {
          var now = Date.now();
          var diff = end - now;
          if (diff <= 0) {
            if (behavior === 'hide' && slide) {
              slide.style.display = 'none';
            } else if (expiredEl) {
              if (timeEl) timeEl.hidden = true;
              expiredEl.hidden = false;
            }
            clearInterval(iv);
            return;
          }
          var d = Math.floor(diff / 86400000);
          var h = Math.floor((diff % 86400000) / 3600000);
          var m = Math.floor((diff % 3600000) / 60000);
          var sec = Math.floor((diff % 60000) / 1000);
          var parts = [];
          if (d > 0) parts.push(d + 'g');
          parts.push(pad(h) + ':' + pad(m) + ':' + pad(sec));
          if (timeEl) timeEl.textContent = parts.join(' ');
        }
        function pad(n) { return n < 10 ? '0' + n : '' + n; }

        tick();
        var iv = setInterval(tick, 1000);
      });
    }
  }

  customElements.define('sk-announcement', SkAnnouncement);
})();
